<template>
  <section class="documents-inputs">
    <section-title>DocumentsInput Component</section-title>
    <form-wrap>
      <form-field-set legend="Single Document">
        <documents-input
          v-model="documentsInput"
        />
      </form-field-set>
      <form-field-set legend="Multiple Documents">
        <documents-input
          :multiple="true"
          v-model="multiDocumentsInput"
        />
      </form-field-set>
    </form-wrap>
  </section>
</template>

<script>
import PlaygroundCommmonMixin from '@/mixins/pages/playground/PlaygroundCommon'
import FormFieldSet from '@/components/forms/FormFieldSet'
import FormWrap from '@/components/forms/FormWrap'
import SectionTitle from '@/components/ui/SectionTitle'
import DocumentsInput from '@/components/forms/DocumentsInput'

export default {
  name: 'DocumentsInputs',
  mixins: [PlaygroundCommmonMixin],
  components: {
    FormFieldSet,
    FormWrap,
    SectionTitle,
    DocumentsInput
  },
  data () {
    return {
      documentsInput: {},
      multiDocumentsInput: []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/playground/DocumentsInputs.vue